class Board {
  constructor({
    id = null,
    name = '',
    queryParams = {},
    divId = null,
    createdAt = null,
    updatedAt = null,
    uid = null,
  } = {}) {
    this.id = id;
    this.name = name;
    this.queryParams = queryParams;
    this.divId = divId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.uid = uid;
  }

  setData(data) {
    this.id = data.id;
    this.name = data.name;
    this.queryParams = data.queryParams || {};
    this.divId = data.divId;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.uid = data.uid;
  }

  toUpdate() {
    return {
      name: this.name,
      queryParams: this.queryParams,
      divId: this.divId,
    };
  }
}

export default Board;
